import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '@/core/http'
import { BaseQueryConfig, Response } from '@/core'
import { VerifyUserInfo } from '../auth'
import {
  UpdateUserProfileParams,
  GetUserOrdersParams,
  GetUserOrdersResponse,
  GetUserOrderDetailsParams,
  GetUserOrderDetailsResponse,
} from './userProfile.api.types'

export const userProfileApi = createApi({
  reducerPath: 'userProfileApi',
  baseQuery: baseQuery(),
  endpoints: (builder) => ({
    getUserInfo: builder.query<Response<VerifyUserInfo>, void>({
      query: () => ({
        url: '/users/profile/info',
        method: 'get',
      }),
    }),
    updateProfileImage: builder.mutation<Response<void>, UpdateUserProfileParams>({
      query: ({ data }: UpdateUserProfileParams) => {
        const { profilePic, ...rest } = data
        const config: BaseQueryConfig = { url: '/users/profile/update', method: 'put' }

        if (!rest.phone) rest.phoneCountryCode = undefined

        if (profilePic) {
          const formData = new FormData()
          Object.entries(rest).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
              formData.append(key, String(value))
            }
          })
          formData.append('profilePic', profilePic)
          return { ...config, data: formData }
        }
        return { ...config, data: rest }
      },
    }),
    deleteProfileImage: builder.mutation<Response<void>, void>({
      query: () => ({
        url: '/users/profile/picture',
        method: 'delete',
      }),
    }),

    // user orders
    getUserOrders: builder.mutation<Response<GetUserOrdersResponse>, GetUserOrdersParams>({
      query: (data) => ({
        url: '/users/orders/list',
        method: 'post',
        data,
      }),
    }),

    // booking details
    getUserOrderDetails: builder.mutation<
      Response<GetUserOrderDetailsResponse>,
      GetUserOrderDetailsParams
    >({
      query: ({ bookingId }) => ({
        url: `/users/orders/${bookingId}`,
        method: 'get',
      }),
    }),
  }),
})

export const {
  useGetUserInfoQuery,
  useLazyGetUserInfoQuery,
  useUpdateProfileImageMutation,
  useDeleteProfileImageMutation,
  useGetUserOrdersMutation,
  useGetUserOrderDetailsMutation,
} = userProfileApi

export default userProfileApi.reducer
